import StudentTileTabItem from "@/js/components/StudentTile/components/StudentTileTabItem";
import { BackgroundTab, isBeingRestricted, WindowData } from "@/js/components/RegularClassroomUser/utils";
import WebsiteOrSignatureListModal from "@/js/components/WebsiteOrSignatureListModal";
import React, { FC, useState } from "react";
import { UserInfo } from "@/js/api/authApi";
import { IGetSignatureDbReturn } from "@/stores/signatureStore_I";
import { User } from "@/js/utils/userUtils";

interface StudentTileTabViewProps {
	windowData: WindowData;
	signatureDb: IGetSignatureDbReturn;
	user: User;
	tabItemLimit: number;
	canCloseTab: boolean;
	isClassActive: boolean;
	isMonitoring: boolean;
	forceCloseTab: (tabId: string, setLoading: boolean) => void;
	openP2pModal?: (user: UserInfo, tabId: string, chromeId: string, windowId: string, isActiveTab: boolean) => void;
}

const StudentTileTabView: FC<StudentTileTabViewProps> = (props: StudentTileTabViewProps) => {
	// states to handle tab list view modal
	const [listModalTitle, setListModalTitle] = useState("");
	const [listModalItems, setListModalItems] = useState<BackgroundTab[]>([]);
	const [listModalIsMonitorMode, setListModalIsMonitorMode] = useState(false);
	const [listModalOpen, setListModalOpen] = useState(false);

	// tab list view modal handler
	const openListModal = (title: string, items: BackgroundTab[] | undefined, isMonitorMode: boolean) => {
		setListModalTitle(title);
		setListModalItems(items ?? []);
		setListModalIsMonitorMode(isMonitorMode);
		setListModalOpen(true);
	};

	const closeListModal = () => {
		setListModalOpen(false);
	};

	const backgroundTabs = props.windowData.background_tabs
		? props.windowData.background_tabs.map((bt) => ({
				url: bt.tabUrl,
				favicon: bt.favIcon,
				title: bt.title,
				tab_id: bt.tab_id,
			}))
		: [];

	const tabsData = [props.windowData, ...backgroundTabs];
	const tabsToDisplay = tabsData.slice(0, props.tabItemLimit);

	return (
		<div className="StudentTileContent_tabsList">
			{tabsToDisplay.map((tab, i) => (
				<StudentTileTabItem
					key={`${tab.tab_id || tab.url}-${i}`}
					item={tab}
					chromeId={props.windowData.chrome_id}
					chromeWindowId={props.windowData.chrome_window_id}
					signatureDb={props.signatureDb}
					user={props.user}
					forceCloseTab={props.forceCloseTab}
					canCloseTab={props.canCloseTab}
					classIsActive={props.isClassActive}
					openP2pModal={props.openP2pModal}
					isMonitorMode={props.isMonitoring}
					isRestricted={isBeingRestricted(props.windowData)}
				/>
			))}
			<WebsiteOrSignatureListModal
				title={listModalTitle}
				open={listModalOpen}
				activeTab={tabsToDisplay[0]}
				items={listModalItems}
				signatureDb={props.signatureDb}
				user={props.user}
				onClose={closeListModal}
				forceCloseTab={props.forceCloseTab}
				canCloseTab={props.canCloseTab}
				classIsActive={props.isClassActive}
				isMonitorMode={listModalIsMonitorMode}
			/>
			{tabsData.length > props.tabItemLimit ? (
				<div className="StudentTileContent_showMoreTabs">
					<button className="" onClick={() => openListModal("Open Tabs", props.windowData.background_tabs, listModalIsMonitorMode)}>
						{`Show All (${tabsData.length})`}
					</button>
				</div>
			) : null}
		</div>
	);
};

export default StudentTileTabView;
